import React from "react";
import { ListItem, ListItemAvatar, ListItemText, ListItemIcon, Typography, IconButton } from "@material-ui/core";
import { ChevronRight } from "@material-ui/icons";
import AbtcAvatar from "../../../custom/Avatar";

const AgentListItem = ({ agent, onSelect, divider, enableArrowIcon, enableHover }) => {
  return (
    <ListItem
      button={enableHover}
      alignItems="flex-start"
      onClick={enableArrowIcon ? () => onSelect(agent) : null}
      divider={divider}
    >
      <ListItemAvatar>
        <AbtcAvatar
          imageUrl={agent.photoUrl}
          disableLink
        />
      </ListItemAvatar>

      <ListItemText
        primary={
          <Typography
            variant="body1"
            color="textPrimary"
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {`${agent.name} (${agent.id})`}
          </Typography>
        }
        secondary={
          <Typography
            variant="body1"
            color="textSecondary"
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {agent.email}
          </Typography>
        }
      />

      {enableArrowIcon && (
        <ListItemIcon>
          <IconButton>
            <ChevronRight />
          </IconButton>
        </ListItemIcon>
      )}
    </ListItem>
  );
};

export default AgentListItem;
